module.exports = __webpack_public_path__ + "img/rambutan-350x184.3d5f8dab.jpg";